import React, { useEffect } from "react";
import { authAPI } from "../../../api/auth/authAPI";

export default function TokenPage() {
  useEffect(() => {
    const urlParams = new URLSearchParams(window.location.search);
    const code = urlParams.get("code");
    //const code = window.location.search.substr(3);
    //const code = window.location.search.substr(7);

    console.log("TOKEN PAGE " + code);

    window.sessionStorage.setItem("code", code);

    //const { code } = getParameterByName('SAMLResponse');

    if (!code) {
      window.sessionStorage.removeItem("user");
      window.location.href = "/authorize";
    }

    async function getTokenAndHandleResponse(code) {
      try {
        const response = await authAPI.getToken(code);
        debugger;
        if (response.status !== 200) {
          window.sessionStorage.removeItem("user");
          window.sessionStorage.removeItem("code");
          window.location.href = "/unauthorized";
        } else {
          window.sessionStorage.removeItem("user");
          window.sessionStorage.setItem("user", JSON.stringify(response.data));
          debugger;
          window.location.href =
            window.sessionStorage.getItem("ingressPath") || "/";
        }
      } catch (err) {
        window.sessionStorage.removeItem("user");
        window.sessionStorage.removeItem("code");
        window.location.href = "/unauthorized";
      }
    }

    getTokenAndHandleResponse(code);
  }, []);

  return (
    <>
      <div className="loading-container"></div>
      <div className="loading-widget">
        <div className="loading-img"></div>
      </div>
    </>
  );
}
